import React, { FC } from 'react';
import { Overlay } from '@moda/om';
import { Loading } from '../../Loading';

import './GridLoading.scss';

interface Props {
  show: boolean;
}

export const GridLoading: FC<Props> = ({ show }) => (
  <Overlay className="GridLoading" show={show}>
    <Loading />
  </Overlay>
);
